/**************************************************
 * Nombre:       BarraPc
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, InputAdornment, TextField, Typography} from "@mui/material";
import logo from '../../Recursos/logo_blanco.svg'
import logo_oscuro from '../../Recursos/logo_color.svg'
import {SECCIONES} from "../../Constantes";
import {theme} from "../../Tema";
import {Search, ShoppingCart} from '@mui/icons-material'
import {useNavigate} from "react-router";
import {useIrRuta} from "../../Utilidades/useIrRuta";
import {useState} from "react";
import {useProductosCarrito} from "../../Modulo_Carrito_Flotante/Funcionamiento/Hooks/useProductosCarrito";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {useCarritoFlotante} from "../../Modulo_Carrito_Flotante/Hooks/useCarritoFlotante";


const BarraPc = ({esVerde}) => {
    const navigate = useNavigate();
    const {ir} = useIrRuta()
    const [palabra, setPalabra] = useState('')
    const {productos} = useProductosCarrito()
    const {Carrito, abrir} = useCarritoFlotante()


    const obtenerValorTotal = (prods) => {


        let val = 0

        for (let i = 0; i < prods.length; i++) {
            val += prods[i].valor * prods[i].cantidad
        }
        return val

    }


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: !esVerde ? '#ffffff00' : '#00000000', color: !esVerde ? '#fff' : '#000'}}
        >

            <Carrito/>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'space-between'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <img
                            onClick={() => navigate('/Home')}
                            src={!esVerde ? logo : logo_oscuro} width={240} height={'auto'}
                            style={{cursor: 'pointer'}}/>


                    </Grid>

                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 1}} sx={{justifyContent: 'flex-start'}}>

                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 9}} sx={{justifyContent: 'flex-end',}}>
                    <Grid
                        container
                        justifyContent={'space-between'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={2}
                    >

                        {SECCIONES.map((it, index) => {
                            return (
                                <Typography
                                    onClick={() => ir(it)}
                                    sx={{
                                        transition: 'all .2s ease-in-out',
                                        fontWeight: 500,
                                        fontSize: 16,
                                        borderBottom: 2,
                                        cursor: 'pointer',
                                        borderColor: '#ffffff00',
                                        "&:hover": {
                                            borderColor: theme.palette.primary.main,
                                        }

                                    }}>
                                    {it}
                                </Typography>
                            )
                        })}

                        <TextField
                            size={'small'}
                            variant={'outlined'}
                            color={!esVerde ? 'secondary' : 'primary'}
                            label={'Buscar producto'}
                            fullWidth={false}
                            sx={{width: 300}}
                            value={palabra}
                            onChange={e => setPalabra(e.target.value)}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    navigate('/Catalogo/Palabra/' + palabra)
                                }
                            }}
                            slotProps={{
                                input: {
                                    endAdornment: (
                                        <InputAdornment
                                            onClick={() => {
                                                if (palabra) {
                                                    navigate('/Catalogo/Palabra/' + palabra)
                                                }
                                            }
                                            }
                                            position="end"
                                            sx={{cursor: 'pointer'}}
                                        >
                                            <Search color={!esVerde ? 'secondary' : 'primary'}/>
                                        </InputAdornment>
                                    ),
                                    disableUnderline: true,
                                    sx: {borderRadius: 10, color: !esVerde ? '#fff' : '#000', fontWeight: 500}
                                },
                                inputLabel: {
                                    sx: {marginLeft: 0, borderRadius: 10, color: !esVerde ? '#fff' : '#000'}
                                }
                            }
                            }
                        />

                        <Button
                            onClick={() => abrir()}
                            variant={'text'} startIcon={<ShoppingCart/>}
                            sx={{color: !esVerde ? '#fff' : '#000', fontWeight: 600, px: 1}}

                        >
                            {formatoMoneda(obtenerValorTotal(productos))}
                        </Button>

                    </Grid>

                </Grid>


            </Grid>

        </Grid>
    )

}
export default BarraPc    